<template>
  <div>
    <nav-breadcrumb :menu="[{label: '审核详情'}]"/>
    <el-steps class="step-shenpi">
    <el-step :title="'提交申请'" :description = "$moment(detailData.m__createdDate).format('YYYY-MM-DD HH:mm:ss')">
      <i class="step-start" slot="icon"></i>
    </el-step>
    <el-step v-if="approvalMortgageListcount>0" :title="'抵押审核 '+approvalMortgageList[0].a__approverName" :description="$moment(approvalMortgageList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalMortgageList[0].a__approvingStatus)" >
      <i class="step-mid" slot="icon"></i>
    </el-step>
      <el-step v-if="approvalMortgageListcount>1" :title="'风控审核 '+approvalMortgageList[1].a__approverName" :description="$moment(approvalMortgageList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalMortgageList[1].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>


    <div class="el-step is-end" v-if="approvalMortgageListcount==0&&detailData.m__applicationStatus == 'Pending Approval'">
      <i class="step-over" slot="icon"></i>
      <p class="text1">抵押审核</p>
      <p class="text2">待审核</p>
    </div>
    <div class="el-step is-end" v-if="approvalMortgageListcount==1&&detailData.m__applicationStatus == 'Pending Approval'">
      <i class="step-over" slot="icon"></i>
      <p class="text1">风控审核</p>
      <p class="text2">待审核</p>
    </div>

    </el-steps>
    <el-row>
      <el-col class="grid-content bg-purple" @tab-click="handleClick">
        <el-row>
          <el-tabs v-model="tabName">
            <el-tab-pane label="客户信息" name="CustomerSummary">
              <customer-detail-component v-model="detailData" :is-show-pic1="true"/>
            </el-tab-pane>
            <el-tab-pane label="抵押车辆" name="ApplicationProcess">
              <customer-detail-vehicles-component v-model="detailData.vehicles" :is-show-pic1="true"/>
            </el-tab-pane>
           <!-- <el-tab-pane label="审核意见" name="ApplicationStatus" v-if="detailData.m__applicationStatus == 'Rejected' ">
              <panel label="审核结果">
                <form-build-component
                  :form-data="item"
                  :form-columns="approvalFormColumns"
                  class="formTable"
                  v-for="(item,idx) in approvalList"
                  :key="idx"
                ></form-build-component>
              </panel>
            </el-tab-pane>-->
            <el-tab-pane label="担保信息" name="guarantor" class="bg-purple">
              <customer-detail-guarantor-component v-model="detailData"/>
            </el-tab-pane>
            <el-tab-pane label="挂靠公司" name="ext-company" class="bg-purple">
              <customer-detail-ext-company-component v-model="detailData" />
            </el-tab-pane>
            <el-tab-pane label="授信审批"  name="credit" class="bg-purple">
              <el-steps :active="6" class="step-shenpi">
                <el-step :title="'提交授信  '"  :description="$moment(detailData.ac__createdDate).format('YYYY-MM-DD HH:mm:ss')">
                  <i class="step-start" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>0" :title="Status2CN(approvalList[0].a__approvalType)+approvalList[0].a__approverName" :description="$moment(approvalList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[0].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>

                <el-step v-if="approvalListcount>1" class="step-spec" :title="Status2CN(approvalList[1].a__approvalType)+approvalList[1].a__approverName"  :description="$moment(approvalList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[1].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>2" class="step-spec" :title="Status2CN(approvalList[2].a__approvalType)+approvalList[2].a__approverName"  :description="$moment(approvalList[2].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[2].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>3" class="step-spec" :title="Status2CN(approvalList[3].a__approvalType)+approvalList[3].a__approverName"  :description="$moment(approvalList[3].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[3].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>4" class="step-spec" :title="Status2CN(approvalList[4].a__approvalType)+approvalList[4].a__approverName"  :description="$moment(approvalList[4].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[4].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step :title="'完成'" v-if="detailData.ac__applicationStatus == 'Approved'" >
                  <i class="step-over" slot="icon"></i>
                </el-step>
              </el-steps>

              <panel>
                <data-table
                  :table-data="approvalArry"
                  :columns="tableColumns"
                  :is-pagination-show="false"
                />
              </panel>
              <template>
                <div>
                  <el-form label-width="150px">
                    <el-row>
                      <panel title="授信信息" border>
                        <el-col :span="24">
                          <el-form-item label="贷款产品：">
                            {{detailData.p__productName}}
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="授信类型：">
                            {{detailData.cr__creditType}}
                          </el-form-item>
                          <el-form-item label="授信起始日：">
                            {{detailData.cr__creditValidity1}}
                          </el-form-item>
                          <el-form-item label="贷款比例：">
                            {{detailData.cr__financingRatio}} %
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="授信额度：">
                            {{detailData.cr__lineOfCredit}}
                          </el-form-item>
                          <el-form-item label="授信到期日：">
                            {{detailData.cr__creditValidity2}}
                          </el-form-item>
                          <el-form-item label="贷款阈值：">
                            {{detailData.cr__threshold|formatMoney}} 元
                          </el-form-item>
                        </el-col>
                      </panel>
                    </el-row>
                  </el-form>
                </div>
              </template>
              <panel title="附件列表">
                <files-data-table :files.sync="files.files"></files-data-table>
              </panel>
              <panel title="抵押审核">
                <data-table
                  :table-data="approvalMortgageArry"
                  :columns="tableColumns"
                  :is-pagination-show="false"
                />
              </panel>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <button-back/>
    </el-row>
  </div>
</template>

<script>
  import CustomerDetailComponent from '../../components/CustomerDetailComponent'
  import xhr from '../../../utils/xhr'
  import ButtonBack from '../../../components/ButtonBack'
  import Panel from '../../../components/Panel'
  import FormBuildComponent from "../../../components/FormBuild";
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import CustomerDetailVehiclesComponent from "../../components/CustomerDetailVehiclesComponent";
  import CustomerDetailGuarantorComponent from "../../components/CustomerDetailGuarantorComponent";
  import CustomerDetailExtCompanyComponent from "../../components/CustomerDetailExtCompanyComponent";

  export default {
    data() {
      return {
        tabName: 'ApplicationProcess',
        detailData: {
          etcs: [],
          sinopecs: [],
          vehicles: [],
        },
        approvalArry:{
          data:[],
          count:0,
        },
        approvalMortgageArry:{
          data:[],
          count:0,
        },
        tableColumns: [
          {
            label: '节点',
            field: 'node',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作人',
            field: 'approverName'
          },
          {
            label: '操作时间',
            field: 'time',
            formatter: function (r,c,v) {
              return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
            }
          },
          {
            label: '操作结果',
            field: 'status'
          }, {
            label: '操作备注',
            field: 'remarks'
          },

        ],
        approvalList:{},
        approvalListcount:0,
        approvalMortgageList:{},
        approvalMortgageListcount:0,
        files:{},
        formData: {
          c__applicationId: this.$route.query['c.applicationId'],
          a__approvingStatus: 'Rejected',
          a__remarks: ''
        },
        approvalFormColumns: [
          {
            label: '审核意见',
            field: 'a__approvingStatus',
            formatter: function (r,v) {
              return Status2CN(v)
            }
          },
          {
            label: '审核人',
            field: 'a__approverName'
          },
          {
            label: '审核时间',
            field: 'a__approvingDate',
            formatter: function(r,v) {
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            },
            span: 24,
          },
          {
            label: '审核备注',
            field: 'a__remarks',
            span: 24
          }
        ],
        approvalList: []
      }
    },
    components: {
      CustomerDetailExtCompanyComponent,
      CustomerDetailGuarantorComponent,
      CustomerDetailVehiclesComponent,
      FormBuildComponent,
      ButtonBack,
      CustomerDetailComponent,
      Panel
    },
    computed: {

    },
    mounted() {
      this.getApplyingVehicleMortgageCustomerDetail()

      this.getApplyingCustomerCreditAttachment()
    },
    methods: {
      Status2CN,
      setMortgageApproval:function(){
        let count =1
        this.approvalMortgageArry.data.push(
          {
            node:'提交申请',
            approverName:'System',
            time:this.detailData.m__createdDate,
            status:'提交成功',
            remarks:'',

          }
        )

        for(var i=0;i<this.approvalMortgageList.length;i++){
          let name =this.approvalMortgageList[i].a__approvalType


          this.approvalMortgageArry.data.push(
            {
              node:name,
              approverName:this.approvalMortgageList[i].a__approverName,
              time:this.approvalMortgageList[i].a__approvingDate,
              status:Status2CN(this.approvalMortgageList[i].a__approvingStatus),
              remarks:this.approvalMortgageList[i].a__remarks,

            }
          )
          count++


        }
        this.approvalMortgageArry.count = count
        console.log(this.approvalArry)
      },
      setApproval:function(){
        let arr=[]
        let count =2
        this.approvalArry.data.push(
          {
            node:'提交授信',
            approverName:'System',
            time:this.detailData.cr__createdDate,
            status:'提交成功',
            remarks:'',

          }
        )

        for(var i=0;i<this.approvalList.length;i++){
          let name =this.approvalList[i].a__approvalType

          this.approvalArry.data.push(
            {
              node:name,
              approverName:this.approvalList[i].a__approverName,
              time:this.approvalList[i].a__approvingDate,
              status:Status2CN(this.approvalList[i].a__approvingStatus),
              remarks:this.approvalList[i].a__remarks,

            }
          )
          count++


        }
        this.approvalArry.count = count
        console.log(this.approvalArry)
      },
      getApplyingVehicleMortgageCustomerDetail: function () {
        xhr.getApplyingVehicleMortgageCustomerDetail({
          'm.applicationId': this.$route.query['m.applicationId']
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.detailData = res.data.data
              this.getApplyingCustomerCreditAttachment(this.detailData.ac__applicationId)
              this.getCustomerApprovalList(this.detailData.ac__applicationId)
              this.getMortgageApprovalList(this.$route.query['m.applicationId'])
            }
          }catch(e){}
        })
      },
      handleClick: function () {

      },
      getMortgageApprovalList: function(applicationId) {
        xhr.getCustomerApprovalList(
          {
            'a.applicationId': applicationId,
            pageSize: 100
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.approvalMortgageList = res.data.data
                this.approvalMortgageListcount = res.data.count
                console.log( res.data.count)

                this.setMortgageApproval()
              }
            }catch (e) {

            }
          }
        )
      },
      getApplyingCustomerCreditAttachment:function(applicationId){
        xhr.getApplyingCustomerCreditAttachment({
          'c.applicationId': applicationId
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.files = res.data.data
            }
          }catch(e){}
        })
      },

      getCustomerApprovalList: function(applicationId) {
        xhr.getCustomerApprovalList(
          {
            'a.applicationId': applicationId,
            pageSize: 100
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.approvalList = res.data.data
                this.approvalListcount = res.data.count
                this.setApproval()
              }
            }catch (e) {

            }
          }
        )
      },
      updateApproveCustomer: function (approvingStatus) {
        this.formData.a__approvingStatus = approvingStatus

        this.$confirm('确认该操作？').then(()=>{
          xhr.updateApproveCustomer(this.formData, res=>{
            try{
              if(res.data.status == 'success') {
                this.$alert('操作成功！')
                this.$router.back()
              }
            }catch (e) {
            }
          })
        }).catch(()=>{

        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerApplyingVehicleMortgageDetail.vue